import { AccessCodes } from '@pm2/api';

/**
 * Recursively parses the course descriptor to extract the first relevant
 * chapter for the current user.
 */
function getFirstValidChapterDescriptorInCourse(revision, currentDescriptor, currentChildIndex = 0) {
  const currentChild = currentDescriptor.children?.[currentChildIndex];
  if (!currentChild) {
    return undefined;
  }

  // Navigate into chapter groups given that they actually contain relevant
  // chapters for the given user
  if (currentChild.type === "ChapterGroup") {
    const validChildInChapterGroup = getFirstValidChapterDescriptorInCourse(revision, currentChild, 0);
    if (validChildInChapterGroup) {
      return validChildInChapterGroup;
    } else {
      return getFirstValidChapterDescriptorInCourse(revision, currentDescriptor, currentChildIndex + 1);
    }
  }
  if (currentChild.accessCode !== AccessCodes.ALLOWED || revision?.disabledContentIds[currentChild.id]?.disabled) {
    return getFirstValidChapterDescriptorInCourse(revision, currentDescriptor, currentChildIndex + 1);
  }

  // If all other checks have passed, then we've found the first valid chapter
  // descriptor!
  return currentChild;
}

export { getFirstValidChapterDescriptorInCourse };
//# sourceMappingURL=util.get-first-valid-chapter-descriptor-in-course.js.map
